// extracted by mini-css-extract-plugin
export default {"chip":"VRhxRzyx","lime":"iMgvNzvM","mint":"pDsidfid","sage":"EP3I2gJc","tan":"N2h7yszs","warn":"iYMdt5Qy","alert":"xPySEVxc"};